// VerifyMobileNumber.js
import React,{useState} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Input
} from 'reactstrap';
import './mobileNumberVerification.css';
import { toastContainer } from '../../utils/toast';
import { connect } from 'react-redux'
import * as url from '../../utils/url'
import axios from '../../axios'
import { withRouter } from "react-router";
import PhoneInputWithCountrySelect from 'react-phone-number-input';

// adjust this path to wherever you exported your formatter
import { formatPhoneNumber } from '../../utils/constants';

const VerifyMobileNumber = ({ onContinue,history  }) => {


    const [phoneNumber,setPhoneNumber]=useState('')

    const value = localStorage.getItem("mfaContext")||{}
    const user=JSON.parse(value)

  console.log("history in verifyMobile Number:", history)


  const handleSubmit = function (e) {
    e.preventDefault();
    
    if(phoneNumber){
        const paylaod={
            email:user.email,
            mobileNumber:phoneNumber
        }
        axios.post(url.sentOtpForPhone,paylaod).then(({data})=>{
      
            if(data.data.success){
              history.push("/two-factor-authentication", { mobileNumber: phoneNumber })
            }
            toastContainer("OTP sent to provided number",'success')


        }).catch((err)=>{
            const isDublicateMobile=err.response&&err.response.data.errors&&err.response.data.errors.message

            if (isDublicateMobile){
              toastContainer(err.response.data.errors.message,'error')
            }else{
              console.log("error:", err)
            }
        })
    }
    
  };

  return (
    <div className="mfa-setup">
      <Container className="mfa-container">
        <Row className="justify-content-center">
          <Col xs="12" sm="10" md="8" lg="5">
         <button type="button" className="tfa__resend" onClick={()=>history.push('/login')}>
           <span className="tfa__caret">‹</span> Back to login 
         </button>
            <Card className="mfa-card">
              <CardBody>
                <h1 className="mfa-title">
                  Enter your phone number to set up Multi-Factor Authentication
                </h1>
                <p className="mfa-subtitle">
                  Your organization requires an additional form of verification to make your account more secure.
                </p>

                <Form onSubmit={handleSubmit} noValidate>
                  <FormGroup>
                    <div className="phone-input-row">
                      {/* fixed to +1 so UI remains the same but doesn't conflict with formatter */}
                      {/* <Input
                        type="select"
                        name="countryCode"
                        className="country-code-select"
                        value="+1"
                        disabled
                        aria-label="Country code"
                      >
                        <option value="+1">+1</option>
                      </Input>

                      <Input
                        type="tel"
                        name="phone"
                        className="phone-number-input"
                        placeholder="(123) 456-7890"
                        autoComplete="tel"
                        aria-label="Phone number"
                        inputMode="numeric"
                      /> */}
                       <PhoneInputWithCountrySelect
                        placeholder="Enter Mobile number"
                        value={phoneNumber}
                        onChange={(number) =>{setPhoneNumber(number)}
                        }
                        className="form-control p-0"
                        defaultCountry="US"
                        style={{
                          width: "615px",
                          height:"50px"
                        }}
                      />
                    </div>
                  </FormGroup>

                  <Button type="submit" color="dark" className="continue-btn" block>
                    Continue
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};


export default connect()(withRouter(VerifyMobileNumber))
